//data-marquee-speed="15"
const marquees = document.querySelectorAll('[data-marquee]');

function marqueeSetup() {

    Array.from(marquees).forEach((item) => {
        setTimeout(() => {
            // To force them all restart at the same time, otherwise they are out of sync
            Array.from(item.querySelectorAll(".marquee_group")).forEach((group) => {
                group.style.animation = 'none';
                setTimeout(() => group.style.animation = null, 10);
            });
        }, 10);
        const contentWrapper = item.querySelector('.marquee_group');
        const duplicateTimes = Math.ceil(window.innerWidth / contentWrapper.offsetWidth);

        // remove all clones
        let groupClone = item.querySelector('.marquee_group_clone');
        if (groupClone) groupClone.remove();
        const clones = item.querySelectorAll('.marquee_item_clone');
        Array.from(clones).forEach((clone) => clone.remove());
        item.style.animation = 'none';
        const originalItems = Array.from(contentWrapper.children);
        for (let i = 0; i < duplicateTimes; i++) {
            for (let target of originalItems) {
                const clone = target.cloneNode(true);
                clone.classList.add('marquee_item_clone');
                clone.ariaHidden = true;
                contentWrapper.appendChild(clone);
            }
            if (i > 10) {
                break;
            }
         }
        groupClone = contentWrapper.cloneNode(true);
        item.appendChild(groupClone);
        const marqueeSpeed = item.dataset.marqueeSpeed ? item.dataset.marqueeSpeed : 15;
        const duration = marqueeSpeed / 1440 * contentWrapper.offsetWidth;
        item.style.setProperty('--duration', `${duration}s`);
    });
}

try {
    marqueeSetup()
} catch (e) {
    console.error("marquee error", e)
}